import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { NextPage } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const EcboTerms: NextPage<{ locale: string }> = ({ locale }) => {
  const { t } = useTranslation()
  const router = useRouter()

  useEffect(() => {
    router.push('/terms/user/space')
  }, [router])

  return null
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  }
}

export default EcboTerms
